import PropTypes from "prop-types";
import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "./Recaptcha.css";

/**
 * A component that acts as a wrapper to google recptcha. It shows the recaptcha and sets the token when the user solves it.
 *
 * @param {Object} props
 * @param {{current: any}} props.recaptchaRef - A ref to the recaptcha
 * @param {string | undefined} props.sitekey - Fallback site key if it wasn't found in the env variables
 * @param {(token: string | null)=>void} props.onChange - A function that gets called when the recaptcha is solved
 * @returns {JSX.Element}
 */

const Recaptcha = ({ recaptchaRef, sitekey, onChange }) => {
  const handleExpire = () => {
    console.log("reCAPTCHA expired. Please try again.");
    onChange(null);
    recaptchaRef.current?.reset();
  };

  const handleError = () => {
    console.error("reCAPTCHA encountered an error. Resetting...");
    try {
      recaptchaRef.current?.reset();
    } catch (error) {
      console.error("Error resetting reCAPTCHA:", error);
      throw new Error("Failed to reset reCAPTCHA. Please reload the page.");
    }
  };

  return (
    <div
      className="recaptcha-container"
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
        margin: "20px auto",
      }}
    >
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY || sitekey}
        onChange={onChange}
        onExpired={handleExpire}
        onErrored={handleError}
      />
    </div>
  );
};

Recaptcha.propTypes = {
  recaptchaRef: PropTypes.object.isRequired,
  sitekey: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default Recaptcha;
